export default "//cloud.imgsmail.ru/cloud.mail.ru/179961/img/build/aside-promo-modal/cloud-dark.jpg";